import { render, staticRenderFns } from "./CustomFieldColumn.vue?vue&type=template&id=125d1f18&scoped=true&"
import script from "./CustomFieldColumn.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFieldColumn.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d1f18",
  null
  
)

export default component.exports